export const increaseLevel = state => {
  state.level += 1;
};

export const resetLevel = state => {
  state.level = 0;
};

export const setGame = (state, game) => {
  state.game = game;
};
